(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linklist"] && !Shopify.designMode) return;
  try {
    
  const membershipForms = document.querySelectorAll('[data-membership-form]')
  membershipForms.forEach((form) => {
    const formError = form.querySelector('[data-form-error]')
    form.addEventListener('submit', (event) => {
      const membershipSelect = form.querySelector('[data-membership-select]')
      if (membershipSelect.value === '') {
        event.preventDefault()
        formError.classList.remove('hidden')
        return false
      }
    })
    document.addEventListener('select:not-empty', () => {
      formError.classList.add('hidden')
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-details"] && !Shopify.designMode) return;
  try {
    
  class LocationDetails extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.navItems = this.querySelectorAll('.location-details__nav-item')

      this.navItems.forEach((item) => {
        item.addEventListener('click', this.handleNavClick.bind(this))
      })

      this.content = this.querySelector('.location-details__content')
      this.content.style.height = `${this.querySelector('.location-details__item.active').clientHeight}px`

      window.addEventListener('resize', () => {
        this.content.style.height = `${this.querySelector('.location-details__item.active').clientHeight}px`
      })
    }
    handleNavClick(event) {
      event.preventDefault()
      const targetId = event.currentTarget.getAttribute('data-id')
      this.navItems.forEach((item) => {
        item.classList.remove('active')
      })
      event.currentTarget.classList.add('active')
      this.querySelectorAll('.location-details__item').forEach((item) => {
        item.classList.remove('active')
        if (item.getAttribute('data-id') === targetId) {
          item.classList.add('active')
          this.content.style.height = `${item.clientHeight}px`
        }
      })
    }
  }
  customElements.define('location-details', LocationDetails)

  } catch(e) { console.error(e); }
})();
})();
